// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3iw2q","container":"styles_container__qs5Lu","title":"styles_title__NCi1j","text":"styles_text__UB6ja","textColor":"styles_textColor__bEDU1"};